import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, Text } from 'react-native';
import { ProcessTypes } from 'fitbeat.gym-core';
import { GymTypes } from 'fitbeat.models';

import { getNextBookingStep } from '../actions';
import { styles as sharedStyles } from './Styles';
import { ConfirmAction } from '../components';
import { GymResolver } from '../../services';

class ConfirmChangePartnerBooking extends Component {
  changeBooking = () => {
    const { getNextBookingStep, userProfile } = this.props;
    getNextBookingStep(userProfile, ProcessTypes.ConfirmedPartnerBookingChange);
  }

  rejectChangeBooking = () => {
    const { getNextBookingStep, userProfile } = this.props;
    getNextBookingStep(userProfile, ProcessTypes.Start);
  }

  render() {
    const { t, workoutSession } = this.props;
    const gym = GymResolver.getByName(workoutSession.gymName);
    return (
      <View style={sharedStyles.containerNoPadding}>
        <ConfirmAction
          title={t('changeConfirmationText')}
          subtitle={t('changeConfirmationMetaText', { context: gym.type === GymTypes.Home ? 'home' : '' })}
          leftButtonText={t('yesChangeBooking')}
          rightButtonText={t('no')}
          leftButtonPress={this.changeBooking}
          rightButtonPress={this.rejectChangeBooking}
          leftButtonOverrideStyles={sharedStyles.leftButtonOverideStyle}
          rightButtonOverrideStyles={sharedStyles.rightButtonOverideStyle}
        />
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workoutSession: state.bookings.bookingWizard.workoutSession,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getNextBookingStep: (userProfile, processType) => dispatch(getNextBookingStep(userProfile, processType)),
  };
};

ConfirmChangePartnerBooking = connect(mapStateToProps, mapDispatchToProps)(ConfirmChangePartnerBooking);
export default translate(['bookings'], { wait: true })(ConfirmChangePartnerBooking);
